<template>
  <div
    id="AdminHomeOrders"
    class="orders"
  >
    <el-table
      class="AdminHomeOrders el-table--scrollable-x"
      header-row-class-name="AdminHomeOrders-HeaderRow"
      header-cell-class-name="AdminHomeOrders-HeaderCell"
      cell-class-name="AdminHomeOrders-Cell"
      border
      :data="orders"
      :height="tableHeight"
      :row-class-name="hightLightCancelRow"
      :empty-text="`お探しの注文は見つかりませんでした。`"
    >
      <!-- メッセージ（やり取り） -->
      <el-table-column
        class="column"
        prop="[
          hasUnReadMessage,
          messageCount,
          unreadMessageCount,
        ]"
        label="メッセージ"
        width="99"
      >
        <template slot-scope="scope">
          <!-- メッセージの未読・既読状態で３段階表示にする -->
          <!-- ①: メッセージが無い場合はアイコン・バッジ非表示 -->
          <!-- ②: メッセージがあり、未読を含む場合はアイコンとバッジを表示 -->
          <!-- ③: メッセージがあり、すべて既読の場合はアイコン灰色表示でバッジ非表示 -->
          <el-badge
            :value="scope.row.unreadMessageCount"
            :hidden="!scope.row.hasUnReadMessage"
            class="unread-message-badge"
          >
            <font-awesome-icon
              v-if="scope.row.messageCount"
              :icon="['fal', 'comment-dots']"
              :class="{
                read: !scope.row.hasUnReadMessage,
              }"
              size="2x"
            />
          </el-badge>
        </template>
      </el-table-column>

      <!-- 注文番号 -->
      <el-table-column
        prop=""
        label="注文番号"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.parentOrder">
            {{
              scope.row.parentOrder.orderNumber
                ? "6" + scope.row.parentOrder.orderNumber
                : scope.row.parentOrder.orderNumber
            }}
          </div>
          <div v-else>
            {{
              scope.row.orderNumber
                ? "6" + scope.row.orderNumber
                : scope.row.orderNumber
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 得意先 -->
      <el-table-column
        prop=""
        label="得意先"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.clientGroup">
            <div>{{ scope.row.clientGroup.id }}</div>
            <div>{{ scope.row.clientGroup.name }}</div>
          </div>
          <div v-else>
            <div>[存在しない得意先]</div>
          </div>
        </template>
      </el-table-column>

      <!-- 納入先 -->
      <el-table-column
        prop=""
        label="納入先"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.deliveryDestination">
            <div>{{ scope.row.deliveryDestination.id }}</div>
            <div>{{ scope.row.deliveryDestination.name }}</div>
          </div>
          <div v-else>
            <div>
              [存在しない納入先]
            </div>
          </div>
        </template>
      </el-table-column>

      <!-- 注文日時 -->
      <el-table-column
        prop label="注文日時"
        width="180"
      >
        <template #header>
          <OrderSortDropDown
            text="注文日時"
            sortKey="orderedAt"
            :sortParams="sortParams"
            @updateSortDirection="$listeners['updateSortDirection']"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.orderedAt | formattedYearDate }}
        </template>
      </el-table-column>

      <!-- お客様名 -->
      <el-table-column
        prop=""
        label="お客様名"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.customer && scope.row.customer.name }}
          </div>
        </template>
      </el-table-column>

      <!-- 注文ステータス -->
      <el-table-column
        prop="status.name"
        label="注文ステータス"
        width="130"
      />

      <!-- 商品 -->
      <el-table-column
        prop=""
        label="商品"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.detail.product && scope.row.detail.product.name }}/{{
              scope.row.detail.productVariation &&
                scope.row.detail.productVariation.size
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 彫/書 -->
      <el-table-column
        prop=""
        label="彫/書"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.parentOrder">
            {{
              scope.row.parentOrder.detail.typography &&
              scope.row.parentOrder.detail.typography.printType === "CARVE"
                ? "彫り"
                : "書き"
            }}
          </div>
          <div v-else>
            {{
              scope.row.detail.typography &&
              scope.row.detail.typography.printType === "CARVE"
                ? "彫り"
                : "書き"
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 出荷日 -->
      <el-table-column
        label="出荷日"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.status.code === 'CONFIRMED' || scope.row.status.code === 'SHIPPED'">
            {{ scope.row.detail.deliveryDate | formattedYearDate }}
          </template>
        </template>
      </el-table-column>

      <!-- 担当者 -->
      <el-table-column
        prop="client.name"
        label="担当者"
      />

      <!-- 操作 -->
      <el-table-column
        label="操作"
        width="180"
      >
        <template slot-scope="scope">
          <el-button @click="onClickDetail(scope.row)">
            注文内容を確認
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OrderUsecase from "@/usecases/order.usecase";
import OrderSortDropDown from "@/components/OrderSortDropDown";

const TABLE_HEIGHT = "360px";
const RESIZE_TIMEOUT_DURATION = 0.333 * 1000;

export default {
  name: "AdminHomeOrders",
  components: {
    OrderSortDropDown,
  },
  props: {
    status: String,
    orders: Array,
    sortParams: Object,
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      dialog: false,
      ordersIDS: [],
      userRole: "",
      result: null,
      tableHeight: TABLE_HEIGHT,
      isEmptyOrder: false,
      resizeTimeout: null,
    };
  },
  created () {
    this.userRole = this.$store.state.user.role;
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);

      // Some devices may not be able to properly retrieve table height during initial loading
      setTimeout(() => {
        this.resize();
      }, 500);
    });
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
      isFilter: state => state.orderForm.filter,
    }),
  },
  watch: {
    isEmptyOrder: function () {
      if (this.isEmptyOrder) {
        var element = document.getElementsByClassName("el-table__empty-block");
        for (var i = 0; i < element.length; i++) {
          element[i].innerHTML = "お探しの注文は見つかりませんでした。";
          element[i].style.color = "#909399";
          element[i].style.height = "10rem";
        }
      }
    },
    orders: function () {
      this.onResize();
    },
  },
  methods: {
    /**
     * [setPosition description]
     * @param   {[type]}  value  [value description]
     */
    setPosition (value) {
      const element = document.querySelector(".el-table__body-wrapper");

      if (element) {
        element.scrollTop = value;
      }
    },

    /**
     * [resize description]
     */
    resize () {
      const element = document.querySelector("#AdminHomeOrders");

      if (element) {
        this.tableHeight = element.offsetHeight;
      }
    },

    /**
     * [onResize description]
     */
    onResize () {
      // debounce
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(this.resize, RESIZE_TIMEOUT_DURATION);
    },

    // got to order detail screen
    onClickDetail (row) {
      const { id } = row;
      const { $router } = this;
      const element = document.querySelector(".el-table__body-wrapper");
      const position = element.scrollTop;

      this.$emit("keepHomeState", position);
      this.$store.commit("orderForm/isFiltered", false);

      $router.push(`/admin/orders/${id}`);
    },

    // hight light in cancel request status order's row
    hightLightCancelRow (order) {
      // キャンセルのリクエストがある場合
      if (order.row.status.code === "CANCEL_REQUEST") {
        return "cancel-row-style";
      }

      return "";
    },

    confirmDialog () {
      this.dialog = true;
    },

    handleStop (e) {
      e.stopPropagation();
    },

    handleChange (id) {
      if (this.ordersIDS.includes(id)) {
        this.ordersIDS.splice(this.ordersIDS.indexOf(id), 1);
      } else {
        this.ordersIDS.push(id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.orders {
  width: 100%;
  overflow: hidden;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: $background-gray-deep;
    height: 100px;
  }
}

::v-deep .AdminHomeOrders {
  width: 100%;

  &-HeaderCell,
  &-Cell {
    text-align: center;
  }

  &-HeaderCell {
    font-size: 0.75rem;
  }

  &-Cell.product-name .cell {
    padding: 0 15% !important;
    text-align: left;
  }
}

::v-deep {
  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: fixed !important;
    border-collapse: collapse !important;
  }

  .el-table--border {
    border: none;
    border-top: 1px solid $--border-color-lighter;
  }

  // .el-table--scrollable-x .el-table__body-wrapper {
  //   overflow-x: hidden !important;
  // }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: white;
  }

  .el-table {
    // font-size: 1rem;

    th {
      height: 36px;
      padding: 0;
      background-color: $background-gray-light !important;
    }

    td {
      // padding: 0 !important;
      padding: 12px 0 !important;
      font-size: 14px;
    }

    .customer-name {
      color: $text-extra-light; // #909399;
      text-align: left;
    }

    .unread-message-badge {
      font-size: 16px;

      .read {
        color: $--border-color-lighter;
      }

      // バッジサイズ
      sup {
        top: 11px;
        right: 6px;
      }
    }

    // 回出位牌
    .child-row-style {
      background: $background-purple-lighter;
      font-size: 0.9em;

      &:hover > td {
        background-color: $background-purple-lighter !important;
      }
    }

    // キャンセル
    .cancel-row-style {
      background: $background-cancel;

      &:hover > td {
        background-color: $background-cancel !important;
      }
    }
  }
}
</style>
